import { render, staticRenderFns } from "./Tool.vue?vue&type=template&id=84a53f3c"
import script from "./Tool.vue?vue&type=script&lang=js"
export * from "./Tool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports